import en from './en'
import cn from './cn'
import ct from './ct'
import japanese from './japanese'
import korean from './korean'
export default {
  en,
  cn,
  ct,
  japanese,
  korean
}



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js